import { z } from "zod";
import { MethodsInputSchema } from "../methodsInput";

export const JacobBearInputsSchema = MethodsInputSchema.extend({
  exploitationFlow: z.number().positive(),
  saturatedThicknessBase: z.number(),
  saturatedThicknessTop: z.number(),
  effectivePorosity: z.number().positive(),
  transmissivity: z.number().positive(),
}).refine((data) => data.saturatedThicknessBase > data.saturatedThicknessTop, {
  path: ["saturatedThicknessBase"],
});

export type JacobBearInputs = z.infer<typeof JacobBearInputsSchema>;
